var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-ball",on:{"mousedown":_vm.startDrag,"click":function($event){$event.stopPropagation();return _vm.copyCheckedValues.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }